import React, {useCallback, useEffect, useState} from "react";
import {axiosInstance} from "../utilities/AxiosConfig";
import Cookies from "js-cookie";
import {notify} from "../components/toast";
import {ToastContainer} from "react-toastify";
import {MunshiMenu} from "../components/Menu";
import dayjs from "dayjs";
import {generateRandomString} from "../utilities/randomGenerator";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import WorkerGrid from "../components/Worker/WorkerGrid";
import {WorkerPrint} from "../print/WorkerPrint";
import {Auths} from "../utilities/getAuthDep";


export const Worker = ({handle}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [workerDepList, setWorkerDepList] = useState(null)
    const [level] = useState(Auths);
    const [user, setUser] = useState("Guest");
    const [database, setDatabase] = useState("Test");
    useEffect(() => {

        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database') || "Test");
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/workerDep/').then((response) => {
            setWorkerDepList(response.data)
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    useEffect(() => {
        setLoading(true)
        axiosInstance.get('/worker/').then((response) => {
            if (response.data) {
                setData(response.data)
            } else {
                setData([{
                    id: generateRandomString(4),
                    firstName: "",
                    lastName: "",
                    title: "Mr.",
                    nic: "",
                    department: "",
                    basicSalary: 0.0,
                    address: "",
                    fixedSalary: true,
                    mobilePhone: "",
                    employed: true,
                    repeat: false,
                    repeatCount: 0,
                    hiredDate: dayjs(new Date()).format('YYYY-MM-DD'),
                    startTime: "09:00:00",
                }])
            }
        }).catch((error) => {
            notify(error.message, "error")
        }).finally(
            setLoading(false)
        )
    }, [])
    const handleAction = useCallback(({mode, _data}) => {
        if (!_data) return;
        let newData = _data
        switch (mode) {
            case "Save": {
                if (newData.firstName !== "") {
                    const itemToSave = newData
                    setLoading(true)
                    axiosInstance.post('worker/', itemToSave).then(res => {
                        if (res.data > 0) {
                            if (!Number.isInteger(newData.id) || newData.id === 0) {
                                setData(data.map(it => {
                                    if (it.id === 0 || !Number.isInteger(it.id)) {
                                        it.id = res.data
                                    }
                                    return it
                                }))
                            }
                            notify("Successfully saved", "success")
                        } else {
                            notify("Failed to save", "error")
                        }
                    }).catch(err => {
                        notify(err.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                }
            }
                break;
            default: {
                const employed = _data.employed
                if (employed) {
                    return;
                } else {
                    setLoading(true)
                    const id = _data.id
                    axiosInstance.delete(`worker/${id}`)
                        .then((response) => {
                            if (response.data > 0) {
                                notify("Successfully deleted", "success")
                            } else {
                                notify("Failed to delete", "error")
                            }
                        }).catch((error) => {
                        notify(error.message, "error")
                    }).finally(
                        setLoading(false)
                    )
                }
            }
        }
    }, [data])
    const PrintTools = () => {
        const [ingredients, setIngredients] = useState([]);
        const onIngredientsChange = (e) => {
            let _ingredients = [...ingredients];
            if (e.checked)
                _ingredients.push(e.value);
            else
                _ingredients.splice(_ingredients.indexOf(e.value), 1);
            setIngredients(_ingredients);
        }
        const handlePrint = (_ing) => {
            let _data = [...data]


            for (let i in _ing) {
                switch (_ing[i]) {
                    case "Employed" : {
                        _data = _data.filter(it => it.employed)
                        break;
                    }
                    case "Fixed" : {
                        _data = _data.filter(it => it.fixedSalary)
                        break;
                    }

                    default: {
                        return
                    }
                }
            }
            WorkerPrint(_data, "Zubair")
        }
        return (
            <div className=" flex flex-column  justify-content-center align-items-end   gap-3">
                    <Button label="Print" icon="pi pi-print" className="p-button-success" onClick={() => {
                        handlePrint(ingredients)
                    }}/>
                <div className="card flex flex-row flex-wrap justify-content-start shadow ">
                    <div className="flex align-items-center p-1">
                        <Checkbox inputId="ingredient1" name="pizza" value="Employed" onChange={onIngredientsChange}
                                  checked={ingredients.includes('Employed')}/>
                        <label htmlFor="ingredient1" className="ml-2">Employed</label>
                    </div>
                    <div className="flex align-items-center p-1">
                        <Checkbox inputId="ingredient2" name="pizza" value="Fixed" onChange={onIngredientsChange}
                                  checked={ingredients.includes('Fixed')}/>
                        <label htmlFor="ingredient2" className="ml-2">Fixed Salary</label>
                    </div>
                </div>

            </div>
        )
    }
    const WorkerSelect = () => {
        if (data && !loading && workerDepList) {
            return (
                <>
                    <WorkerGrid data={data.filter(it => !it.delivered)} setData={setData} setAction={handleAction}
                                workerDepartment={workerDepList.map((it) => {
                                    return it.name
                                })}
                    />
                </>

            )
        } else {
            return null
        }
    }
    if (!loading && data && workerDepList) {
        return (
            <>
                <ToastContainer/>
                <div className="flex flex-row justify-content-between  h-auto w-full pd-10">
                    <MunshiMenu handle={handle}/>
                    <PrintTools/>
                </div>
                <div className="flex justify-content-end ">

                        <h1 className="font-bold text-center md:text-left align-self-center mr-4 text-base md:text-4xl">RMA</h1>
                </div>
                <div className="flex w-full h-auto justify-content-center"><WorkerSelect/></div>
            </>
        );
    }

}